// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* common constants for  the fonts and the buttons styles in the genai tool
reuses these styles for the font and the buttons styles in the nexus tool */

/* constants.css */
:root {
    --letter-spacing: -0.05em;
    --font-size: 0.875rem;  /* 14px */
    --line-height: 1.25rem;  /* 20px */
    --font-weight-400: 400;
    --font-weight-500: 500;
    --font-weight-600: 600;
    --font-weight-700: 700;
    --font-family: "Inter, system-ui, Avenir, Helvetica, Arial, sans-serif",
}


`, "",{"version":3,"sources":["webpack://./src/assets/styles/style_constants.css"],"names":[],"mappings":"AAAA;2EAC2E;;AAE3E,kBAAkB;AAClB;IACI,yBAAyB;IACzB,qBAAqB,GAAG,SAAS;IACjC,sBAAsB,GAAG,SAAS;IAClC,sBAAsB;IACtB,sBAAsB;IACtB,sBAAsB;IACtB,sBAAsB;IACtB;AACJ","sourcesContent":["/* common constants for  the fonts and the buttons styles in the genai tool\nreuses these styles for the font and the buttons styles in the nexus tool */\n\n/* constants.css */\n:root {\n    --letter-spacing: -0.05em;\n    --font-size: 0.875rem;  /* 14px */\n    --line-height: 1.25rem;  /* 20px */\n    --font-weight-400: 400;\n    --font-weight-500: 500;\n    --font-weight-600: 600;\n    --font-weight-700: 700;\n    --font-family: \"Inter, system-ui, Avenir, Helvetica, Arial, sans-serif\",\n}\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
